// extracted by mini-css-extract-plugin
module.exports = {"form":"w1A+c7cj9hvbWiGGQKlBgQ=="};